import { useMemo } from 'react';
import { useParams } from 'react-router';

import { PlanScenarioParams } from 'constants/routes';
import { TQ_ACTIONS } from 'contexts/Permissions/constants';
import { usePermissions } from 'contexts/Permissions/Permissions';
import { GetCurrentUserPermissionsResponse } from 'services/users';

/**
 * True when the user lacks TQ_READ but has a shared-resource grant on the active planning cycle.
 * Defaults to restrictive (true) while permissions are still loading.
 */
export function useIsSpmCollaborationUser(userPermissions: GetCurrentUserPermissionsResponse | undefined): boolean {
  const { hasAccess } = usePermissions();
  const { planningCycleId } = useParams<PlanScenarioParams>();
  const hasRbacAccess = hasAccess({ actions: TQ_ACTIONS.TQ_READ });

  return useMemo(() => {
    if (hasRbacAccess) {
      return false;
    }
    if (!userPermissions || !planningCycleId) {
      return true;
    }
    const allPermissionPaths = userPermissions.shared_resources.flatMap((sharedResource) => {
      return sharedResource.resource_path;
    });
    return allPermissionPaths.includes(planningCycleId);
  }, [userPermissions, planningCycleId, hasRbacAccess]);
}
